import React from 'react';
import { Checkbox } from 'antd';
import type { CargoRes } from 'api/swagger';
import { useSelectCargoStore } from 'shared/stores/use-select-cargos.ts';
import { checkIsIndeterminate } from './lib.ts';

interface ICargoCheckboxProps {
  cargo: CargoRes;
  className?: string;
}

export const CargoCheckbox: React.FC<ICargoCheckboxProps> = ({ cargo, className }) => {
  const { setSelectedCargo, deleteSelectedCargo, selectedCargos, selectedCargoItems } = useSelectCargoStore();

  const isSelected = selectedCargos.has(cargo.id);
  const isIndeterminate = checkIsIndeterminate(cargo.cargoItems, selectedCargoItems);

  const handleClick = () => {
    if (isSelected) {
      deleteSelectedCargo(cargo);
    } else {
      setSelectedCargo(cargo);
    }
  };

  return (
    <Checkbox
      indeterminate={isIndeterminate && !isSelected}
      checked={isSelected}
      className={className}
      onClick={handleClick}
    />
  );
};
